import styled, { createGlobalStyle } from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

import {
  MIDLARGE_BREAKPOINT,
  XXSMALL_BREAKPOINT,
  SMALL_BREAKPOINT,
  PLATFORM_BREAKPOINT,
} from '../../../../style'

export const Container = styled.div<{ isAdmin: boolean; isNavCollapsed?: boolean }>`
  width: ${({ isNavCollapsed }) => (isNavCollapsed ? '100%' : '12.25rem')};
  background: white;
  overflow-y: scroll;
  position: fixed;
  height: fit-content;
  border-radius: 1.25rem;
  top: ${({ isAdmin }) => (isAdmin ? `6.75rem` : `4.75rem`)};
  max-height: calc(100vh - ${({ isAdmin }) => (isAdmin ? `8.25rem` : `6.25rem`)});

  & {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  &::-webkit-scrollbar {
    display: none;
  }

  @media all and (max-width: ${PLATFORM_BREAKPOINT}) {
    left: 0;
    top: ${({ isAdmin }) => (isAdmin ? `5.25rem` : `3.25rem`)};
    bottom: 0;
    border-radius: 0;
    height: auto;
    margin-top: 0;
    max-height: 100%;
  }

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    width: 100%;
    background: none;
    display: none;
  }
`
export const Logo = styled.div`
  will-change: filter;
  min-width: 5.875rem;
  width: 5.875rem;
  height: 5.875rem;
  background: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 0.375rem;
  filter: drop-shadow(0 2px 48px rgba(0, 0, 0, 0.1));
  overflow: hidden;
`
export const Left = styled.div`
  display: block;
  margin-bottom: 1.5rem;
  padding: 1.5rem 0 0;

  h2 {
    padding: 0 1.5rem;
    text-align: center;
    font-weight: 900;
    font-size: 1.125rem;
    line-height: 1.75rem;
    margin-bottom: 0.375rem;
  }

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    display: none;
    padding: 0;
  }
`
export const Right = styled.div`
  position: relative;

  & {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  &::-webkit-scrollbar {
    display: none;
  }

  @media all and (max-width: ${PLATFORM_BREAKPOINT}) {
    margin-bottom: ;
  }

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    display: none;
  }

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    width: 100%;
    overflow: scroll;
    height: 5.25rem;
    overflow-y: hidden;
    padding: 1rem 0 1rem 1rem;
    box-sizing: content-box;
  }
`
export const H2 = styled.h2`
  font-weight: 900;
  font-size: 1.5rem;
  line-height: 2.125rem;
  margin-bottom: 0.25rem;
  color: ${colors.black1};
  max-width: 100%;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;

  picture {
    vertical-align: text-bottom;
  }

  img {
    margin-left: 0.75rem;
  }
`
export const BrandStats = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.875rem;
  line-height: 1.5rem;
  font-weight: 700;
  color: ${colors.black1};
  padding: 0 1.25rem;

  span {
    font-weight: 400;
  }
`
export const BrandNav = styled.div`
  display: flex;

  @media all and (max-width: ${MIDLARGE_BREAKPOINT}) {
    justify-content: center;
  }

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    position: absolute;
    white-space: nowrap;
    left: 1.25rem;
    top: 1rem;
  }
`
export const ReactToolTipStyles = createGlobalStyle`
  .__react_component_tooltip {
    && {
      background: rgba(32, 32, 32, 0.8);
      backdrop-filter: blur(12px);
      border-radius: 0.5rem;
      font-weight: 400;
      font-size: 0.625rem;
      line-height: 1rem;

      &::after {
        display: none;
      }

      &.show {
        opacity: 1;
      }
    }
  }
`
export const ButtonWrapper = styled.div<{ isAdmin?: boolean; isSubBrandView?: string | null }>`
  margin: 0 auto;
  margin-bottom: 1.5rem;
  margin-top: -0.5rem;
  display: flex;
  justify-content: center;
  padding: 0 0.75rem;

  button {
    position: relative;
    padding-left: 3rem;

    @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
      width: 100%;
    }
    &::after {
      content: '';
      position: absolute;
      background: url(https://res.cloudinary.com/ninety-seconds/image/upload/v1674058986/arrow-left-white.svg)
        no-repeat left center;
      height: 1rem;
      width: 1rem;
      left: 1rem;
      top: 0.875rem;
    }
  }

  ${({ isSubBrandView, isAdmin }) =>
    isSubBrandView === 'true' &&
    `
      position: fixed;
      height: 3.5rem;
      z-index: 1;
      background: #fff;
      width: 100%;
      left: 0;
      right: 0;
      margin : 0;
      top: ${isAdmin ? `84px` : `52px`};
      display: none;

      button {
        height: 2.75rem;
      }

      @media all and (max-width: ${SMALL_BREAKPOINT}) {
        display: flex;
        justify-content: center;
        align-items: end;
      }
  `};
`
export const Menu = styled.ul`
  padding-left: 1.5rem;
  margin-bottom: 1.5rem;

  @media all and (max-width: ${PLATFORM_BREAKPOINT}) {
    margin-bottom: 0;
  }

  li {
    height: 1.5rem;
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 1.5rem;

    picture {
      margin-right: 1rem;
      height: 1.5rem;
      display: inline-block;
      width: 1.5rem;
    }

    > a,
    div {
      font-weight: 700;
      font-size: 0.875rem;
      color: ${colors.black1};
      transition: all 0.3s ease-in-out;
      cursor: pointer;
      line-height: 1.5rem;

      &:hover {
        font-weight: 900;
      }
    }
  }

  .active {
    &::after {
      content: '';
      position: absolute;
      right: 0;
      bottom: 0;
      width: 3px;
      background: ${colors.adaptBlue};
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
      height: 2.25rem;
      top: 50%;
      transform: translate(0%, -50%);
    }

    a,
    div {
      font-weight: 900;
    }
  }
`
export const Centered = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`
export const OrderTrigger = styled.div<{
  isAdmin: boolean
  isActive: boolean
  isSubBrandView: string | null
}>`
  font-weight: 900;
  font-size: 1.25rem;
  line-height: 1.75rem;
  display: none;
  color: ${colors.black1};
  cursor: pointer;
  position: fixed;
  height: 52px;
  width: 100%;
  left: 0;
  padding: 0 1.25rem;
  border-bottom: 1px solid ${colors.gandalf};
  z-index: 998;
  background: white;
  text-transform: capitalize;
  ${({ isSubBrandView, isAdmin }) =>
    isSubBrandView === 'true'
      ? `top: ${isAdmin ? `8.75rem` : `6.75rem`};`
      : `top: ${isAdmin ? `5.25rem` : `3.25rem`};`} 
    
  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    display: flex;
    align-items: center;
  }

  &::after {
    content: '';
    display: inline-block;
    width: 0.75rem;
    height: 0.75rem;
    background: url(https://res.cloudinary.com/ninety-seconds/image/upload/v1687196819/-design-system/arrow-down.svg)
      no-repeat center;
    margin-left: 0.5rem;
    background-position: center ${({ isActive }) => (isActive ? `0` : `0.25rem `)};
    rotate: ${({ isActive }) => (isActive ? `180deg` : `0`)};
    transition: all 0.2s ease-in-out;
  }

  picture {
    margin-right: 0.875rem;
    line-height: 1.25rem;
  }
`
export const MobileMenu = styled.ul`
  position: absolute;
  background: white;
  box-shadow: 0 2px 48px rgba(0, 0, 0, 0.25);
  border-radius: 0.75rem;
  top: 3.25rem;
  z-index: 9999;

  li {
    font-weight: 700;
    font-size: 0.875rem;
    line-height: 1.5rem;
    height: 3rem;
    border-bottom: 1px solid ${colors.gandalf};
    padding: 0 0.75rem;
    display: flex;
    align-items: center;

    a {
      color: ${colors.black1};
    }

    picture {
      margin-right: 1rem;
      width: 1.5rem;
    }
  }
`
export const DefaultLogo = styled.div`
  width: 5.875rem;
  height: 5.875rem;
  border-radius: 50%;
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 2.125rem;
  display: flex;
  background: #1936d0;
  text-transform: uppercase;
  justify-content: center;
  align-items: center;
`
export const UploadLogoButton = styled.div`
  border-radius: 0.75rem;
  background: ${colors.gandalf};
  height: 2.5rem;
  color: ${colors.black1};
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10.75rem;
  margin: 0 auto;
  cursor: pointer;
  margin-top: 0.75rem;

  > img {
    margin-right: 6px;
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/DashboardHeader/DashboardHeader.style.tsx